export const meta = {
  title: 'Francesco Prisco — Development & Design for Digital Experiences',
  titleShort: 'Francesco Prisco',
  description:
    'Francesco Prisco is an independent developer and designer based in Italy, creating motion-driven websites and digital experiences for studios, brands, and enterprise teams.',
  image: '/social-card.png',
  twitterCard: 'summary_large_image',
};
